import { createContext, useContext } from 'react';

import { BottomSheetId } from '@/types/bottomSheet.type';

export type BottomSheetData = {
    id: BottomSheetId;
    content: React.ReactNode;
};

export type BottomSheetContextType = {
    isVisible: boolean;
    bottomSheetData: BottomSheetData | null;
    showBottomSheet: (data: BottomSheetData) => void;
    hideBottomSheet: () => void;
};

export const BottomSheetContext = createContext<BottomSheetContextType>({
    isVisible: false,
    bottomSheetData: null,
    showBottomSheet: () => {},
    hideBottomSheet: () => {},
});

export function useBottomSheet() {
    return useContext(BottomSheetContext);
}
